// const dev = 'http://uat-api-waic2025.ipmotionmc.com/' // 2025测试
// const prod = 'http://uat-api-waic2025.ipmotionmc.com/' // 2025测试
const dev = 'https://api2025.worldaic.com.cn/' // 正式2025
const prod = 'https://api2025.worldaic.com.cn/' // 正式2025


const base = process.env.NODE_ENV === "production" ? prod : dev

export default base;
// uat swagger地址 https://uat-api2024.worldaic.com.cn/swagger-ui.html
// 2024uat服务器 124.70.163.158  root SYbIbr0g   /mnt/html/


// WEBPACK FOOTER //
// ./src/api/base.js